import { CreateComplaint, dashboard, logout, payment, profile, withdraw } from '../assets';

export const navlinks = [
  {
    name: 'dashboard',
    imgUrl: dashboard,
    link: '/',
  },
  {
    name: 'create-ticket',
    imgUrl: CreateComplaint,
    link: '/create-ticket',
  },
//   {
//     name: 'payment',
//     imgUrl: payment,
//     link: '/',
//     disabled: true,
//   },
//   {
//     name: 'withdraw',
//     imgUrl: withdraw,
//     link: '/',
//     disabled: true,
//   },
  {
    name: 'profile',
    imgUrl: profile,
    link: '/profile',
  },
//   {
//     name: 'logout',
//     imgUrl: logout,
//     link: '/',
//     disabled: true,
//   },
];
